<template>
    <Modal class="modal modal--mob modal-radio-buttons">
        <template #header>
            <h2>{{$t('form_fields.drinking_label')}}</h2>
        </template>
        <template #body>
            <div v-for="d in drinkingOptions" :key="d.code" class="radiobox">
                <input class="form-check-input" type="radio" :id="d.code" :checked="value === d.value">
                <label @click="update(d.value)" class="radiobox__label" :for="d.code">
                    {{$t(`form_fields.drinking_options_${d.value}`)}}
                </label>
            </div>
        </template>
        <template #footer>
            <a @click="$emit('success')" class="skip">{{$t('credits.skip_for_now')}}</a>
        </template>
    </Modal>
</template>

<script>

import Modal from "@/components/generic/Modal";
import { drinking } from "@/service/forms"
import AuthenticatedMixin from "@/mixins/AuthenticatedMixin";

export default {
    name: "OnDemandDrinking",
    mixins: [AuthenticatedMixin],
    components: { Modal },
    props: {
        value: {
            type: [Number, null],
            required: true
        }
    },

    methods: {

        update(value) {

            this.$emit('set', {
                drinking: value
            })

        }

    },

    created() {
        this.drinkingOptions = drinking
    },
    mounted() {
        this.drinking = this.auth.user.drinking
    },
    beforeUnmount() {
        clearTimeout(this.timeout)
    }
}
</script>